import { createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5880cf20")

_pushScopeId("data-v-5880cf20")
const _hoisted_1 = { class: "dhm_head native-drag flex_space_center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex_start_center" }, [
  /*#__PURE__*/_createVNode("i", { class: "keniu_icon" }),
  /*#__PURE__*/_createVNode("span", { class: "keniu_title" }, "可牛软件")
], -1)
const _hoisted_3 = { class: "flex_end_center" }
const _hoisted_4 = { class: "username" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_ctx.viewModel.step === 'home')
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.viewModel.nickname), 1),
            _createVNode("span", {
              class: "toggle_account native-nodrag",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleAccount && _ctx.toggleAccount(...args)))
            }, _toDisplayString(_ctx.viewModel.isLogin ? '切换账号' : '登录'), 1)
          ], 64))
        : _createCommentVNode("", true),
      _createVNode("i", {
        class: "close_icon native-nodrag",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeExchangeModel && _ctx.closeExchangeModel(...args)))
      })
    ])
  ]))
})